export default __webpack_public_path__ + "static/media/Background_00067.d4397990.png";